/**
 * Pre-offer readiness on required items. Complete = 1, Partial = 0.5. Warning only.
 * Neutral by default; red only when dated tasks are overdue.
 * The visible count is complete and partial items, not the half-weighted score.
 */
export default function ReadinessChip({
  pct,
  overdue = 0,
  complete = null,
  partial = null,
  required = null,
  testId = 'preoffer-readiness',
  compact = false,
}) {
  if (pct == null || Number.isNaN(Number(pct))) return null;
  const n = Number(pct);
  const late = Number(overdue) > 0;
  const count = complete != null && required != null
    ? `${complete} complete, ${partial ?? 0} partial of ${required} required`
    : null;
  const headline = count ? `${n}% · ${count}` : `${n}%`;
  const title = late
    ? `${overdue} dated task${overdue === 1 ? '' : 's'} past due. Pre-offer data in hand: ${headline}. Complete counts as 1, Partial as ½. Warning only, nothing is gated.`
    : `Pre-offer data in hand: ${headline}. Complete counts as 1, Partial as ½. Warning only, nothing is gated.`;
  return (
    <span className={`mp-badge ${late ? 'fail' : 'neutral'}`} data-testid={testId} title={title}>
      {compact ? headline : `Data in hand ${headline}`}
      {late ? ` · ${overdue} overdue` : ''}
    </span>
  );
}
